import { Component, ComponentInterface, h, Prop, Element } from '@stencil/core';
import { CardSize, CssClassMap } from './jui-card.model';

@Component({
  tag: 'jui-card',
  styleUrl: 'jui-card.scss',
  shadow: true
})
export class JuiCard implements ComponentInterface {
  /**
   * The card size variant
   */
  @Prop() size: CardSize = CardSize.md;

  /**
   * Removes the default theme border radius
   */
  @Prop() squared: boolean = false;

  /**
   * Adds a box shadow to give the effect of elevation
   */
  @Prop() elevated: boolean = false;

  /**
   * Zoom the card when hovered (only for desktop users)
   */
  @Prop() zoom: boolean = false;

  /**
   * Hug tightly wraps the content of the body with no padding
   */
  @Prop() hug: boolean = false;

  /**
   * Remove borders
   */
  @Prop() borderless: boolean = false;

  /**
   * Swaps header and body colours
   */
  @Prop() inverse: boolean = false;

  /**
   * Adds a highlight border, can be used to draw attention to a specific card
   */
  @Prop() highlight: boolean = false;

  @Element() hostElement: HTMLElement;

  private hasHeaderSlot: boolean;
  private hasFooterSlot: boolean;

  componentWillLoad(): void {
    this.hasHeaderSlot = !!this.hostElement.querySelector("[slot='header']");
    this.hasFooterSlot = !!this.hostElement.querySelector("[slot='footer']");
  }

  private getCssClassMap(): CssClassMap {
    return {
      card: true,
      'card--squared': this.squared,
      'card--elevated': this.elevated,
      'card--zoom': this.zoom,
      'card--highlight': this.highlight,
      'card--has-header': this.hasHeaderSlot,
      'card--has-footer': this.hasFooterSlot,
      'card--hug-content': this.hug,
      'card--no-borders': this.borderless,
      'card--inverse': this.inverse,
      [`card--${this.size}`]: true
    };
  }

  render() {
    return (
      <div class={this.getCssClassMap()}>
        <div class="card__header">
          <slot name="header"></slot>
        </div>
        <slot name="image"></slot>
        <div class="card__body">
          <slot></slot>
        </div>
        <div class="card__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    );
  }
}
